import {
  addressSchema,
  addressUI,
  titleUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import content from '../../../locales/en/content.json';
import { FULL_SCHEMA } from '../../../utils/imports';

const TITLE_TEXT = content['vet-info--home-address-title'];
const DESC_TEXT = content['vet-info--home-address-description'];

const ADDRESS_PROPS = FULL_SCHEMA.properties.veteranHomeAddress.properties;

export default {
  uiSchema: {
    ...titleUI(TITLE_TEXT, DESC_TEXT),
    veteranHomeAddress: addressUI(),
  },
  schema: {
    type: 'object',
    required: ['veteranHomeAddress'],
    properties: {
      veteranHomeAddress: addressSchema({ extend: ADDRESS_PROPS }),
    },
  },
};
